import angular from 'angular';
import BranchFactory from './branch.factory';

let branchModule = angular.module('app.branch', [])

.factory('Branch', BranchFactory)

.name;

export default branchModule;


// WEBPACK FOOTER //
// ./client/app/common/branch/index.js